import { faAngleDown, faChartLine, faHouse, faHandshake } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import constants from "../constants/constants";
import SEO, { pageSEO } from "../components/seo.component";
import { motion } from "framer-motion";
import { fadeUp, stagger } from "../functions/animations";

export default function SellerGuide() {
  const [open, setOpen] = useState(
    new Array(constants.SELLING_GUIDE.length).fill(false)
  );

  const seoConfig = pageSEO.sellerGuide();

  const toggleAccordion = (index) => {
    const temp = [...open];
    temp[index] = !temp[index];
    setOpen(temp);
  };

  return (
    <>
      <SEO {...seoConfig} />

      {/* HERO */}
      <section className="relative overflow-hidden bg-[#fffdfa] pt-40 pb-12">
        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="mx-auto max-w-[1200px] px-6 lg:px-16"
        >
          <motion.div
            variants={fadeUp}
            className="flex items-center justify-center gap-5 mb-8"
          >
            <div className="h-px w-16 bg-[#8b8172]" />

            <span className="text-xs uppercase tracking-[0.45em] text-[#6d655b]">
              Home Selling Journey
            </span>

            <div className="h-px w-16 bg-[#8b8172]" />

          </motion.div>

          <div className="text-center">
            <motion.h1
              variants={fadeUp}
              className="font-serif text-5xl leading-[1.05] text-[#2b2925] md:text-7xl"
            >
              Sell With
              <br />
              Confidence
            </motion.h1>

            <motion.p
              variants={fadeUp}
              className="mx-auto mt-10 max-w-3xl text-lg leading-9 text-[#5f594f]"
            >
              Discover the strategies, preparation steps, and expert guidance
              needed to position your property for success and achieve the best
              possible results.
            </motion.p>
          </div>
        </motion.div>
      </section>

      {/* CONTENT */}
      <section className="bg-[#fffdfa] pb-32">
        <div className="mx-auto max-w-[1200px] px-6 lg:px-16">

          <div className="grid gap-16 lg:grid-cols-[320px_1fr]">
            {/* SIDE PANEL */}
            <motion.div
              variants={fadeUp}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              className="hidden lg:block"
            >
              <div className="sticky top-32 border-t border-[#8b8172]/40 pt-8">
                <div className="flex h-16 w-16 items-center justify-center border border-[#8b8172]">
                  <FontAwesomeIcon
                    icon={faChartLine}
                    className="text-2xl text-[#8b8172]"
                  />
                </div>

                <h3 className="mt-8 font-serif text-4xl leading-tight text-[#2b2925]">
                  Maximize
                  <br />
                  Your Value
                </h3>

                <p className="mt-5 leading-8 text-[#5f594f]">
                  Learn how preparation, presentation, and strategic marketing
                  can help your home stand out in today's market.
                </p>

                <div className="mt-10 space-y-6">
                  <div className="flex items-center gap-4 text-xs uppercase tracking-[0.3em] text-[#6d655b]">
                    <FontAwesomeIcon
                      icon={faHouse}
                      className="text-[#8b8172]"
                    />
                    Prepare Your Home
                  </div>

                  <div className="flex items-center gap-4 text-xs uppercase tracking-[0.3em] text-[#6d655b]">
                    <FontAwesomeIcon
                      icon={faHandshake}
                      className="text-[#8b8172]"
                    />
                    Complete Your Sale
                  </div>
                </div>
              </div>
            </motion.div>

            {/* ACCORDION */}
            <div className="space-y-6">
              {
                constants.SELLING_GUIDE.map((guide, index) => (
                  <motion.div
                    variants={fadeUp}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    key={index}
                    className="border-[15px] border-[#d3d2d0]/70 bg-white"
                  >
                    <button
                      onClick={() => toggleAccordion(index)}
                      className="group flex w-full items-center justify-between gap-5 px-6 py-8 text-left lg:px-10"
                    >
                      <div className="flex items-center gap-6">

                        <div className="flex h-12 w-12 shrink-0 items-center justify-center border border-[#8b8172]">
                          <span className="text-sm text-[#2b2925]">
                            {String(index + 1).padStart(2, "0")}
                          </span>
                        </div>

                        <h2 className="font-serif text-2xl text-[#2b2925] transition-colors duration-300 group-hover:text-[#8b8172] md:text-3xl">
                          {guide.heading}
                        </h2>
                      </div>

                      <FontAwesomeIcon
                        icon={faAngleDown}
                        className={`text-[#8b8172] transition-transform duration-300 ${open[index] ? "rotate-180" : ""}
                        `}
                      />
                    </button>
                    <div
                      className={`grid transition-all duration-500 ease-in-out  ${open[index]
                        ? "grid-rows-[1fr]"
                        : "grid-rows-[0fr]"
                        }
                      `}
                    >
                      <div className="overflow-hidden">
                        <div className="border-t border-[#d8d0c6] px-6 pb-10 pt-8 leading-8 text-[#5f594f] lg:px-10">
                          <div
                            dangerouslySetInnerHTML={{
                              __html: guide.text,
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </motion.div>
                ))
              }
            </div>
          </div>
        </div>
      </section>
    </>
  );
}